/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".qr-container[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center;justify-content:center;padding:20px}canvas[_ngcontent-%COMP%]{background-color:#fff;border-radius:10px;padding:10px;box-shadow:0 2px 10px rgba(0,0,0,.1)}"];
export { styles as styles };
